<div
  class="banner-container d-flex jc-center ai-stretch flex-1 fd-row fd-col--xs"
  [ngClass]="{
    'card banner': shouldShowCard,
    'primary-background': !isWhiteBackground,
    'white-background': isWhiteBackground,
  }"
  [ngStyle]="{
    color: textColor,
    backgroundColor: backgroundColor,
    maxHeight: tileInstance?.customHeight || '100%',
  }"
>
  <div class="banner-title-container order-1 basis-50 basis-100--xs d-flex jc-center ai-center">
    <div class="flex-container d-flex fd-row" style="flex: 0 1 80%">
      <!-- <h3 *ngIf="tileInstance.headingIcon" style="margin-right: 8px; margin-top: -4px; margin-left: -24px">
        <mat-icon class="border-circle light">{{ tileInstance.headingIcon }}</mat-icon>
      </h3> -->

      <div class="content-container d-flex fd-col jc-center ai-start">
        <h3>
          <mat-icon *ngIf="tileInstance?.headingIcon" class="border-circle light">
            {{ tileInstance?.headingIcon }}
          </mat-icon>
          {{ tileInstance?.heading }}
          <b [ngClass]="{ loaded: displayNumberLoaded }" class="total" *ngIf="displayNumber">
            {{ displayNumber | number }}
          </b>
        </h3>
        <p ngClass="secondary-lead" class="hide--xs show">{{ tileInstance?.subHeading }}</p>
        <div class="buttons-container flex-1 d-flex gap-16 ai-center">
          <button
            *ngFor="let button of tileInstance?.linkButtons || []"
            class="link-button flex-1"
            [routerLink]="button.routeLink"
            mat-stroked-button
          >
            <mat-icon *ngIf="button.buttonIcon">{{ button.buttonIcon }}</mat-icon>
            {{ button.buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="banner-image-container basis-50 basis-196--xs order-2 d-flex jc-center ai-center">
    <!-- TODO: Handle fxFlexOrder.xs="-1" responsive order -->
    <img class="banner-image" [src]="contentImgPath" style="flex: 0 0 auto" />
  </div>
</div>
